export default __webpack_public_path__ + "static/media/rain.96af21e1.mp3";